import { Button, Card, Checkbox, Dialog, DialogBody, DialogHeader, Input, List, ListItem, ListItemPrefix } from '@material-tailwind/react';
import { useState } from 'react';
import { toast } from 'react-toastify';

// TODO types
const EditOrInviteUserModal = ({ user, superAdminRoles, selectedSuperAdminRoles, setSelectedSuperAdminRoles, updateUserRoles, inviteUser, editModalOpen, toggleOpen, refreshUsers }) => {

	const [loading, setLoading] = useState(false);
	const [email, setEmail] = useState(user.email);

	const mode = user?.userName === '' ? 'invite' : 'edit';

	const onSubmitUser = mode === 'edit' ? updateUserRoles : inviteUser;

	return (
		<Dialog open={editModalOpen} handler={toggleOpen}>
			<DialogHeader>
				{mode === 'edit'
					? `Edit User: ${user.userName}`
					: `Invite User`}
			</DialogHeader>
			<DialogBody divider>
				<div className="mb-3">
					<Input
						variant="outlined"
						crossOrigin=""
						label="Email"
						value={email || user.email}
						disabled={mode === 'edit'}
						onChange={(e) => setEmail(e.target.value)}
					/>
				</div>
				<Card className="mb-3 border-4">
					<div color="blue-gray" className="px-4 pt-2 text-lg italic font-semibold">
						Select Roles
					</div>
					<RoleChecklist
						superAdminRoles={superAdminRoles}
						selectedSuperAdminRoles={selectedSuperAdminRoles}
						setSelectedSuperAdminRoles={setSelectedSuperAdminRoles}
					/>
				</Card>
				<Button
					className="w-full"
					onClick={() => {
						setLoading(true);
						const roleKeys = Object.keys(
							selectedSuperAdminRoles
						).filter((roleKey) => selectedSuperAdminRoles[roleKey]);
						onSubmitUser({
							userName: user.userName,
							roleKeys,
							email,
						})
							.then((res) => {
								if (!res.success) {
									throw new Error(res.error);
									// return;
								}
								toast.success(`Successfully ${mode === 'edit' ? 'updated' : 'invited'} user`);
							})
							.catch((err) => {
								console.error(err);
								toast.error(
									`Failed to ${mode === 'edit' ? 'update' : 'invite'} user. Please try again`
								);
							})
							.finally(() => {
								refreshUsers();
								toggleOpen();
								setLoading(false);
							});
					}}
				>
					{loading
						? 'Loading'
						: `${mode === 'edit' ? 'Update' : 'Invite'} User`}
				</Button>
			</DialogBody>
		</Dialog>
	);
};

const RoleChecklist = ({
	superAdminRoles,
	selectedSuperAdminRoles,
	setSelectedSuperAdminRoles,
}) => {
	return (
		<List>
			{superAdminRoles.map((role) => {
				return (
					<ListItem disabled={!role.editable}>
						<ListItemPrefix className="mr-3">
							<Checkbox
								id="vertical-list-react"
								crossOrigin=""
								ripple={false}
								className="hover:before:opacity-0"
								containerProps={{
									className: 'p-0',
								}}
								defaultChecked={
									selectedSuperAdminRoles[role.roleKey]
								}
								onClick={(e) => {
									const target: any = e.target;
									const isChecked = target.checked;
									setSelectedSuperAdminRoles({
										...selectedSuperAdminRoles,
										[role.roleKey]: isChecked,
									});
								}}
							/>
						</ListItemPrefix>
						{role.roleName}
					</ListItem>
				);
			})}
		</List>
	);
};

export default EditOrInviteUserModal;
